import * as marietta from '../..';

export interface Tool {
  name: string;
  execute(): void;
}

export const DEBUG_MENU_ID = 'headerMenuFileDebug';
const MENU_ITEM_TAG = 'li';

/** デバッグメニュー（ヘッダーの「デバッグ」ドロップダウン）にツールを1つ追加する */
export class ToolMenu {
  public constructor(tool: Tool) {
    const uuid = marietta.webcad.WebCADGlobal.getGuid();
    this.createUI(tool.name, uuid);
    document.getElementById(uuid)?.addEventListener('click', () => tool.execute());
  }

  private createUI(name: string, uuid: string): void {
    const list = document.querySelector(`#${DEBUG_MENU_ID} .headerDropdownList ul`);
    if (!list) return;

    const item = document.createElement(MENU_ITEM_TAG);
    item.innerHTML = `<button id="${uuid}"><span class="jp">${name}</span><span class="en">${name}</span></button>`;
    list.appendChild(item);
  }
}
